import * as React from "react";
import styled from "@emotion/styled";

// Theme
import { Images } from "../../Themes";

import "./index.css";

const H3 = styled.div`
  font-weight: 700;
  font-size: 2.17em;
  text-align: center;
  color: #fff;
`;

const P = styled.p`
  font-size: 1.15em;
  color: #fff;
`;

const TextBox = styled.div`
  position: relative;
  top: 80px;
  @media (max-width: 800px) {
    top: 0px;
  }
`;

class SupervisorsAndTechnicians extends React.Component<{}> {
  render() {
    return (
      <div>
        <div
          className="section"
          style={{
            background: `url(${Images.mockupTwo})`,
            backgroundPosition: "-100px -150px"
          }}
        >
          <div className="content" />
          <div className="imageBox">
            <TextBox>
              <H3>What Your Manager &amp; Supervisors Wanted All Along</H3>
              <br />
              <P>
                Maintain CMMS helps your management team keep track of all
                company work orders, customer requests, asset management, and
                inventory management. Plan and schedule recurring work orders
                for your teams with ease and see status updates to work orders.
              </P>
            </TextBox>
          </div>
        </div>
        <div
          className="section"
          style={{
            background: `url(${Images.mockupThree})`,
            backgroundPosition: "320px"
          }}
        >
          <div className="content2">
            <TextBox>
              <H3 style={{ color: "#9397ab" }}>
                Get Better Efficiency From Your Technical Team
              </H3>
              <br />
              <P style={{ color: "#9397ab" }}>
                Maintain CMMS is an automated system that helps your technicians
                know what they're supposed to do, and when they're supposed to
                do it. All allsigned work orders are easily accessible with the
                necessary details
                <br />
                for them to get the job done and update the status of it.
              </P>
            </TextBox>
          </div>
          <div className="imageBox2" />
        </div>
      </div>
    );
  }
}

export default SupervisorsAndTechnicians;



// WEBPACK FOOTER //
// ./src/Containers/Home/SupervisorsAndTechnicians.tsx